export const TestIds = {
  background: 'page-bg',
} as const;
